{
  "close": "Zatvori",
  "notifications": "Obaveštenja"
}
